import { instance, errorService } from '@/services/api'
import { masterAPIs, screenType } from '@/services/authConstantsV1'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import { calculateGridHeight, showNotification, customComparator } from '@/services/calculate'
import { gridProperties } from '@/services/column.config'
import Pagination from '@/components/DynamicComponents/Pagination'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function () {
    const checkLength = (rule, value, callback) => {
      if (rule.field === 'value') {
        const reg = /^(?!$)\d{1,9}(?:\.\d{1,2})?$/
        if (!reg.test(value)) {
          callback(new Error('Please enter valid value'))
        } else if (value > 9.99) {
          callback(
            new Error(
              'Construction quality factor should less than or equals to 9.99!',
            ),
          )
        } else {
          callback()
        }
      } else {
        if (String(value).length > 100) {
          callback(
            new Error(
              'Construction quality factor must be less than or equals to 100 characters',
            ),
          )
        } else {
          callback()
        }
      }
    }
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: true,
      spinner: false,
      defaultSortedBy: 'constructionQualityFactor',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      factorList: [],
      visible: false,
      modalTitle: '',
      form: {
        id: undefined,
        constructionQualityFactor: undefined,
        value: undefined,
        isActive: 1,
        isLinked: false,
      },
      rules: {
        constructionQualityFactor: [
          {
            required: true,
            message: 'Please Enter Construction Quality Factor',
            trigger: 'blur',
          },
          { validator: checkLength, trigger: 'blur' },
        ],
        value: [
          { required: true, message: 'Please Enter Value', trigger: 'blur' },
          { validator: checkLength, trigger: 'blur' },
        ],
      },
      selectedRowKeys: [],
      loadRefresh: false,
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      tableState: null,
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadingConfig()
  },
  mounted() {
    this.$root.$on('deleteFactor', this.deleteFactor)
    this.$root.$on('editFactor', this.getFactorById)
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '4') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.factorList = []
        this.loading = true
        this.getColumnSettings(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    this.$root.$off('deleteFactor')
    this.$root.$off('editFactor')
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadingConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.frameworkComponents = gridProperties.master.frameworks
      this.gridOptions.isRowSelectable = node => {
        if (node.data) {
          if (node.data.isLinked) return false
          else return true
        }
      }
      this.columnDefs = gridProperties.master.columns.constructionQualityFactor
    },

    // Refresh Construction Quality Factors
    refreshFactors() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.factorList = []
      this.page = 0
      this.defaultSortedBy = 'constructionQualityFactor'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'constructionQualityFactor',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.selectedRowKeys = []
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getFactors(this.gridOptions)
    },

    // Close the dialog
    handleCancel() {
      this.visible = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Add New Construction Quality Factor
    addNew() {
      this.visible = true
      this.modalTitle = 'Add New Construction Quality Factor'
      this.form.constructionQualityFactor = undefined
      this.form.id = null
      this.form.value = null
      this.form.isActive = 1
      this.form.isLinked = false
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields()
      }
    },

    // Save Construction Quality Factor
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.spinner = true
          let url = masterAPIs.constructionFactor.add
          let method = 'post'
          const req = {
            constructionQualityFactor: this.form.constructionQualityFactor,
            Value: this.form.value,
          }
          if (this.form.id) {
            method = 'patch'
            url = masterAPIs.constructionFactor.details(this.form.id)
          }
          instance[method](url, req)
            .then(response => {
              this.spinner = false
              this.visible = false
              showNotification(
                'success',
                this.form.id
                  ? 'Update Construction Quality Factor'
                  : 'Create Construction Quality Factor',
                this.form.id
                  ? 'Construction Quality Factor updated successfully!'
                  : 'Construction Quality Factor created successfully!',
              )
              if (this.form.id) {
                const newData = [...this.factorList]
                const index = newData.findIndex(i => i.id === this.form.id)
                newData[index] = _.get(response.data, 'result', null)
                newData[index].isLinked = this.form.isLinked
                this.factorList = newData
              } else {
                this.getFactors(this.tableParams)
              }
              this.$refs.ruleForm.resetFields()
            })
            .catch(error => {
              this.spinner = false
              errorService(error)
            })
        }
      })
    },

    // Load Construction Quality Factors
    getFactors(params, type) {
      instance
        .post(masterAPIs.constructionFactor.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          constructionQualityFactor: _.get(
            this.filters,
            'constructionQualityFactor',
            undefined,
          ),
          value: _.get(this.filters, 'value', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.factorList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'constructionFactorTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          if (type === 'sort') {
            this.updateColumnSettings()
          }
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Get Construction Quality Factor By Id
    getFactorById(record) {
      this.visible = true
      this.modalTitle = 'Edit'
      this.spinner = true
      instance
        .get(masterAPIs.constructionFactor.details(record.id))
        .then(response => {
          this.form.id = _.get(response.data, 'result.id', null)
          this.form.constructionQualityFactor = _.get(
            response.data,
            'result.constructionQualityFactor',
            null,
          )
          this.form.value = Number(_.get(response.data, 'result.value', null))
          this.form.isActive = _.get(response.data, 'result.isActive', 0)
          this.form.isLinked = record.isLinked
          this.spinner = false
        })
        .catch(error => {
          this.spinner = false
          errorService(error)
        })
    },

    confirmDelete(record) {
      this.loading = true
      const ids = record ? [record.id] : this.selectedRowKeys
      instance
        .patch(masterAPIs.constructionFactor.delete, ids)
        .then(response => {
          showNotification(
            'success',
            'Delete Construction Quality Factor',
            'Construction Quality Factor deleted successfully!',
          )
          this.refreshFactors()
        })
        .catch(error => {
          this.loading = false
          errorService(error)
        })
    },

    // Delete All Construction Quality Factors
    deleteAllType() {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete ${this.selectedRowKeys.length} selected construction quality factors ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to selected
              construction quality factors
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(null)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Delete Construction Quality Factor
    deleteFactor(data) {
      const that = this
      this.$confirm({
        title: `Are you sure you want to delete '${data.constructionQualityFactor}' ?`,
        content: h => (
          <div style="color:red;">
            <p>
              This action will delete all information related to this
              construction quality factor
            </p>
            <p>Please confirm</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(data)
        },
        onCancel() { },
        class: 'test',
      })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function (s) {
          return s.sort != null
        })
        .map(function (s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = true
      this.factorList = []
      if (sortData.length > 0) {
        this.defaultSortedBy =
          sortData[0]['colId'] === 'option'
            ? 'constructionQualityFactor'
            : sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'constructionQualityFactor'
        this.defaultSortOrder = true
      }
      this.getFactors(this.gridOptions, 'sort')
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'constructionFactorTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.factorList = []
      this.selectedRowKeys = []
      this.getFactors(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.factorList = []
      this.getFactors(this.gridOptions)
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSettings()
      }
    },

    updateColumnSettings() {
      if (this.role === 'Admin') {
        this.tableState = this.gridOptions.columnApi.getColumnState()
        const request = {
          type: screenType.constructionQualityFactor,
          columnDetails: JSON.stringify(this.tableState),
        }
        this.$emit('updateColumns', request)
      }
    },

    getColumnSettings(params) {
      if (this.role === 'Admin') {
        instance
          .get(masterAPIs.columnSetting.get(screenType.constructionQualityFactor))
          .then(response => {
            const tableState = _.get(response.data, 'result.columnDetails', null)
            this.setColumnSettings(params, tableState)
          })
          .catch(error => {
            this.spinner = false
            errorService(error)
          })
      } else {
        this.setColumnSettings(params)
      }
      this.getFactors(params)
    },

    setColumnSettings(params, tableState) {
      if (tableState && this.role === 'Admin') {
        this.tableState = JSON.parse(tableState)
        if (this.tableState.find(i => i.sort)) {
          this.defaultSortedBy = this.tableState.find(i => i.sort).colId
          this.defaultSortOrder =
            this.tableState.find(i => i.sort).sort === 'asc'
        }
        this.tableState[0].hide = false
        this.gridOptions.columnApi.applyColumnState({
          state: this.tableState,
        })
      } else {
        this.defaultSortedBy = 'constructionQualityFactor'
        this.defaultSortOrder = true
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'constructionQualityFactor',
              sort: 'asc',
            },
            {
              colId: 'action',
              hide: this.role !== 'Admin',
            },
            {
              colId: 'isActive',
              hide: this.role !== 'Admin',
            },
            {
              colId: '0',
              hide: this.role !== 'Admin',
            },
          ],
          defaultState: { sort: null },
        })
        params.api.sizeColumnsToFit()
      }
    },
  },
}
